import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { LangService } from 'src/app/services/lang.service';
import { Strings } from 'src/app/const/strings';
import { Lang } from 'src/app/models/lang';
import { TrackingService } from 'src/app/services/tracking.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FooterComponent implements OnInit {

  appUrl: string;
  lang: Lang;
  strings = Strings;

  constructor(
    private langService: LangService,
    private googleAnalyticsService: TrackingService,
  ) { }

  ngOnInit() {
    this.appUrl = this.langService.getAppUrl();
    this.lang = this.langService.getCurrentLang();
  }

  sendAdsTelEvent(event: Event) {
    event.preventDefault();
    const url = 'tel:' + this.strings.carDetail.supportTelNumber[this.lang];
    this.googleAnalyticsService.sendAdsTelEvent(url);
  }

}
